export const OurAdvantagesConst = {
  path: "/single-page/our-advantages",
  title: "НАШИ ПРЕИМУЩЕСТВА",
  contentJSX: (
    <>
      <h2>ПРЕИМУЩЕСТВА ОБУЧЕНИЯ В MSMB</h2>
      <br />
      <p>
        <strong>Государственная лицензия и аккредитация</strong>
      </p>
      <p>
        MSMB работает на основе официальной лицензии, а также обладает государственной и международной аккредитациями. Это гарантирует
        качество образования и признание дипломов как в ЕС, так и в странах СНГ.
      </p>
      <br />
      <p>
        <strong>Программа двойных дипломов — европейский и государственный образец</strong>
      </p>
      <p>
        После окончания обучения вы можете получить двойной диплом: от Malta School of Medicine & Business и одного из партнёрских вузов ЕС.
        Это открывает двери для трудоустройства и дальнейшего обучения в любой точке мира.
      </p>
      <br />
      <p>
        <strong>Образование на английском и русском языках</strong>
      </p>
      <p>Возможность учиться на родном языке. Все программы доступны как на английском, так и на русском языке — без языкового барьера.</p>
      <br />
      <p>
        <strong>Фиксированная цена обучения на весь срок</strong>
      </p>
      <p>Вы заранее знаете полную стоимость образования. Никаких скрытых платежей или неожиданного повышения цен.</p>
      <br />
      <p>
        <strong>Формат обучения — дистанционно (онлайн) или очно в Мальте</strong>
      </p>
      <p>Вы можете учиться дистанционно из любой точки мира в удобное для Вас время или выбрать обучение на кампусе на Мальте.</p>
      <br />
      <p>
        <strong>Гибкий график занятий</strong>
      </p>
      <p>Вы сможете совмещать обучение с работой, семьёй или другими проектами.</p>
      <br />
      <p>
        <strong>Индивидуальное сопровождение</strong>
      </p>
      <p>Небольшие учебные группы и персональный подход преподавателей обеспечивают поддержку на всех этапах обучения.</p>
      <br />
      <p>
        <strong>Карьерная подготовка и стажировки</strong>
      </p>
      <p>
        Практико-ориентированные дисциплины, развитие лидерских качеств, бизнес-симуляции и участие в международных стажировках в клиниках,
        стартапах и корпорациях ЕС.
      </p>
      <br />
      <p>
        <strong>Высокий спрос на выпускников</strong>
      </p>
      <p>
        Образование в MSMB — это инвестиция в будущее. Наши выпускники успешно строят карьеру в медицинских учреждениях, компаниях и научных
        центрах по всему миру.
      </p>
    </>
  ),
  contentSearch: `
  ПРЕИМУЩЕСТВА ОБУЧЕНИЯ В MSMB
  Государственная лицензия и аккредитация
  MSMB работает на основе официальной лицензии, а также обладает государственной и международной аккредитациями. Это гарантирует качество образования и признание дипломов как в ЕС, так и в странах СНГ.
  Программа двойных дипломов — европейский и государственный образец
  После окончания обучения вы можете получить двойной диплом: от Malta School of Medicine & Business и одного из партнёрских вузов ЕС. Это открывает двери для трудоустройства и дальнейшего обучения в любой точке мира.
  Образование на английском и русском языках
  Возможность учиться на родном языке. Все программы доступны как на английском, так и на русском языке — без языкового барьера.
  Фиксированная цена обучения на весь срок
  Вы заранее знаете полную стоимость образования. Никаких скрытых платежей или неожиданного повышения цен.
  Формат обучения — дистанционно (онлайн) или очно в Мальте
  Вы можете учиться дистанционно из любой точки мира в удобное для Вас время или выбрать обучение на кампусе на Мальте.
  Гибкий график занятий
  Вы сможете совмещать обучение с работой, семьёй или другими проектами.
  Индивидуальное сопровождение
  Небольшие учебные группы и персональный подход преподавателей обеспечивают поддержку на всех этапах обучения.
  Карьерная подготовка и стажировки
  Практико-ориентированные дисциплины, развитие лидерских качеств, бизнес-симуляции и участие в международных стажировках в клиниках, стартапах и корпорациях ЕС.
  Высокий спрос на выпускников
  Образование в MSMB — это инвестиция в будущее. Наши выпускники успешно строят карьеру в медицинских учреждениях, компаниях и научных центрах по всему миру.
  `,
};
